import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserSession } from '../../hooks/useUserSession';

/**
 * Composant de protection des routes nécessitant une authentification utilisateur
 * Redirige vers la page d'accueil avec le paramètre login=1 si non authentifié
 */
function RequireUserAuth({ children }) {
  const { isUserAuthenticated, isLoading } = useUserSession();
  const navigate = useNavigate();

  // Afficher un indicateur de chargement pendant la vérification
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '200px',
        }}
      >
        <div>Vérification de l'authentification...</div>
      </div>
    );
  }

  // Rediriger vers la page d'accueil si non authentifié
  if (!isUserAuthenticated) {
    // Rediriger vers la page d'accueil avec le paramètre login pour ouvrir automatiquement la modal
    navigate('/?login=1&next=/dashboard', { replace: true });
    return null;
  }

  // Rendre les enfants si authentifié
  return children;
}

export default RequireUserAuth;
